const yaml = require('js-yaml');

export default class AresConverter {
  // yaml转对象
  static loadAresData(aresData) {
    let obj = null;
    try {
      obj = yaml.safeLoad(aresData);
    } catch (e) {
      obj = null;
    }
    return obj;
  }
  // 对象转yaml
  static dumpAresData(aresObj) {
    let data = '';
    try {
      data = yaml.safeDump(aresObj);
    } catch (e) {
      console.error(e);
      data = '';
    }
    return data;
  };

  static generateAresObj(page, compList) {
    const aresObj = {
      root: {
        conf: page.conf,
        style: page.style,
        children: this.generateAresChildren(compList),
      },
    };
    return aresObj;
  }
  /**
   * 递归组件树
   * 组件字段转成yaml标准字段
   */
  static generateAresChildren(compList) {
    if (!compList) return null;
    return compList.map((item) => {
      const { compId, desc, name, compProps, style, report,  children, parentId, ...rest } = item;

      const exportStyle = {};
      const res =  {
        id: compId,
        desc,
        view: name,
        props: compProps,
        report: report || {},
        ...rest,
      };
      if (style) {
        Object.keys(style).forEach((key) => {
          exportStyle[key] = style[key];
        });
        res.style = exportStyle;
      }
      if (children) {
        res.children = this.generateAresChildren(children);
      }

      return res;
    });
  }
  /**
   * 递归组件树
   * yaml字段转组件字段
   * generateAresChildren的反向操作
   */
  static loadChildren(list, handler) {
    if (!list) return null;
    return list.map((item) => {
      const { id, props, view, style, desc, report, children, ...rest } = item;
      handler && handler(item);
      return {
        desc,
        style,
        compId: id,
        name: view,
        compProps: props,
        report: report || {},
        children: this.loadChildren(children),
        ...rest,
      };
    });
  }
};
